import {NOT_FOUND, FILTER_INPUT_DEBOUNCE_MS} from "./constants"
import debounce from 'lodash.debounce';

class DatatableFilters {

  constructor(type, datatableBlock) {
    this.type = type;
    this.datatable = datatableBlock;
    this.filterBlock = $(`#${type}-filter`);
  }

  init() {
    this.assignEvents();
  };

  assignEvents() {
    const self = this;
    this.filterBlock.find('.filter-reset').on('click', event => {
      this.cleanFilters();
    })
    const filterForm = document.querySelector(`#${this.type}-filter-form`);
    document.querySelector(`#${this.type}-filter-button`).addEventListener('click', event => {
      if (filterForm.style.display === "none") {
        filterForm.style.display = "block";
      } else {
        filterForm.style.display = "none";
      }
    });

    this.filterBlock.find('[type=text]').not(":data('ui-combobox')").each(function() {
      this.addEventListener('keyup', debounce(() => {
        self.applyFilters();
        }, FILTER_INPUT_DEBOUNCE_MS)
      );
    });

    this.filterBlock.find(":data('ui-combobox')").each(function() {
      $(this).combobox({
        change: function(event) {
          self.applyFilters();
        }
      });
    });
  };

  applyFilters() {
    const filters = this.collectFilters();
    for (let key in filters) {
      const columnIndex = this.getColumnIndexByName(key);
      if (columnIndex !== NOT_FOUND) {
        this.datatable.column(columnIndex).search(filters[key]);
      }
    }
    this.datatable.draw();
  };

  getColumnIndexByName(name) {
    const columns = this.datatable.settings().init().columns;
    let foundIndex = NOT_FOUND;
    columns.forEach((column, index) => {
      if (column.name === name) {
        foundIndex = index;
        return;
      }
    });
    return foundIndex;
  }

  collectFilters() {
    let fields = {};

    $(this.filterBlock).find('input:not(.ui-widget),select').each(function() {
      let fieldKey = this.name;

      if (fieldKey === '') {
        return;
      }

      if ($(this).data('field')) {
        fieldKey = $(this).data('field');
      }

      if ($(this).is('[type=checkbox],[type=radiobutton]') && $(this).is(':not(:checked)')) {
        if (!Array.isArray(fields[fieldKey])) {
          if (typeof fields[fieldKey] !== 'undefined') {
            fields[fieldKey] = [fields[fieldKey]];
          } else {
            fields[fieldKey] = [];
          }
        }
        return;
      }

      let value;
      if ($(this).data('select2')) {
        value = $(this).select2('val');
      } else {
        value = $(this).val() || '';
      }

      // check whether we need to set single value or use array
      if (typeof fields[fieldKey] !== 'undefined') {
        if (!Array.isArray(fields[fieldKey])) {
          fields[fieldKey] = [fields[fieldKey]];
        }
        fields[fieldKey].push(value);
      } else {
        fields[fieldKey] = value;
      }
    });

    return fields;
  };

  cleanFilters() {
    this.filterBlock.find('input:text:not(.js-no-reset), select:not(.js-no-reset), textarea').val('');
    this.filterBlock.find('.s2.filter-field:not(.js-no-reset)').select2('val', null, true);
    this.filterBlock.find('input:radio, input:checkbox'
    ).prop('checked', false
    ).prop('selected', false);
    this.datatable.columns().search('');

    this.applyFilters();
  };
}

export {DatatableFilters};
